import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M26.5,30.3 L26.5,52 C26.5,58.5 31.5,63 38.5,63 C45.5,63 50.5,58.5 50.5,52 L50.5,30.3 L45.5,30.3 L45.5,52 C45.5,55 42.5,58 38.5,58 C34.5,58 31.5,55 31.5,52 L31.5,30.3 L26.5,30.3 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;

